"use client"

import * as React from "react"
import Image from "next/image"
import {
    AudioWaveform,
    BarChart3,
    BookOpen,
    Bot,
    Building2,
    ChevronRight,
    CircleAlert,
    CircleUser,
    Clock,
    Code2,
    Cog,
    Compass,
    FileText,
    Frame,
    GalleryVerticalEnd,
    Globe,
    History,
    Home,
    LayoutDashboard,
    LayoutGrid,
    Layers,
    Map,
    Network,
    PieChart,
    Radar,
    Settings2,
    Shield,
    ShieldAlert,
    SquareTerminal,
    User,
    Webhook,
    X
} from "lucide-react"

import {NavOthers} from "@/components/nav-others"
import {NavCore} from "@/components/nav-core"
import {NavUser} from "@/components/nav-user"
import {OrgSwitcher} from "@/components/org-switcher"
import {Badge} from "@/components/ui/badge"
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarRail,
} from "@/components/ui/sidebar"
import {useAuth} from "@/context/AuthContext";

// This is sample data.
const data = {

    navMain: [
        {
            title: "Assets",
            url: "/assets",
            icon: SquareTerminal,
            isActive: true,
            items: [
                {
                    title: "Domains",
                    url: "/assets/domains",
                },
                {
                    title: "DNS Records",
                    url: "/assets/dns-records",
                },
                {
                    title: "IP Addresses",
                    url: "/assets/ip-addresses",
                },
                {
                    title: "CIDR Blocks",
                    url:  "/assets/cidr-blocks",
                },
                {
                    title: "X.509 Certificates",
                    url: "/assets/x509-certificates",
                },
            ],
        },
        {
            title: "Discovery",
            url: "#",
            isActive: true,
            icon: Radar,
            items: [
                {
                    title: "Internet Services",
                    url: "/discoveries/internet-services",
                }
            ],
        },
        {
            title: "Documentation",
            url: "#",
            icon: BookOpen,
            items: [
                {
                    title: "Introduction",
                    url: "#",
                },
                {
                    title: "Get Started",
                    url: "#",
                },
                {
                    title: "Tutorials",
                    url: "#",
                },
                {
                    title: "Changelog",
                    url: "#",
                },
            ],
        },
        {
            title: "Settings",
            url: "/settings",
            icon: Settings2,
            items: [],
        },
    ],
    projects: [
        {
            name: "News Feeds",
            url: "/feeds/for-you",
            icon: Radar,
        },
        {
            name: "Changes Management",
            url: "/changes",
            icon: History,
        },
        // {
        //     name: "Attack Surface Management",
        //     url: "#",
        //     icon: Frame,
        // },
        {
            name: "Digital Presence Management",
            url: "/assets/domains",
            icon: PieChart,
        },
        {
            name: "Assets",
            url: "/assets",
            icon: Map,
        },
    ],
}

export function AppSidebar({...props}: React.ComponentProps<typeof Sidebar>) {
    const authContext = useAuth();
    
    // Check if we're not in production
    const isNotProduction = process.env.NODE_ENV !== 'production';
    
    return (
        <Sidebar collapsible="icon" {...props}>
            <SidebarHeader>
                <div className="relative">
                    <Image alt={"logo"} width={100} height={50} src="/logo_meersec.png"/>
                    {isNotProduction && (
                        <Badge 
                            variant="secondary" 
                            className="absolute -top-1 -right-1 bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-200 text-xs px-1.5 py-0.5"
                        >
                            {process.env.NODE_ENV || 'dev'}
                        </Badge>
                    )}
                </div>
            </SidebarHeader>
            <SidebarContent>
                <NavCore projects={data.projects}/>
                <NavOthers items={data.navMain}/>
            </SidebarContent>
            <SidebarFooter>
                <NavUser user={authContext.user!}/>
            </SidebarFooter>
            <SidebarRail/>
        </Sidebar>
    )
}
